'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = require('react');
var React__default = _interopDefault(React);
var styled = _interopDefault(require('styled-components'));
var PropTypes = require('prop-types');
var PropTypes__default = _interopDefault(PropTypes);
var moment = _interopDefault(require('moment'));
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var _templateObject;
var DIRECTION = {
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right'
};
var SIZE = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var CaretIcon = function CaretIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick,
    direction = _ref.direction,
    title = _ref.title;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE.SMALL:
        return '3';
      case SIZE.STANDARD:
        return '12';
      default:
        return '12';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE.SMALL:
        return '12';
      case SIZE.STANDARD:
        return '12';
      default:
        return '12';
    }
  };
  var getRotation = function getRotation(direction) {
    switch (direction) {
      case DIRECTION.UP:
        return 180;
      case DIRECTION.RIGHT:
        return 90;
      case DIRECTION.DOWN:
        return 0;
      case DIRECTION.LEFT:
        return 270;
      default:
        return 0;
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan, {
    onClick: handleClick,
    canClick: onClick !== undefined,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    className: 'caret-icon',
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 6 12"
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Artboard",
    transform: "translate(-363.000000, -2406.000000)",
    fill: color,
    fillRule: "nonzero"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M370.379216,2409.20657 C370.812197,2408.87871 371.441132,2408.94858 371.783982,2409.36263 C372.126831,2409.77668 372.053765,2410.37812 371.620784,2410.70598 L365.950027,2414.99996 L360.381167,2410.80464 C359.947335,2410.47781 359.872705,2409.87655 360.214477,2409.46169 C360.556249,2409.04682 361.185,2408.97546 361.618833,2409.30229 L365.946858,2412.56282 L370.379216,2409.20657 Z",
    id: "Arrow-right",
    transform: "translate(365.999999, 2411.999960) scale(-1, 1) rotate(".concat(getRotation(direction), ") translate(-365.999999, -2411.999960)"),
    className: 'caret-icon-path'
  })))));
};
CaretIcon.SIZE = SIZE;
CaretIcon.DIRECTION = DIRECTION;
CaretIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE.SMALL, SIZE.STANDARD]),
  direction: PropTypes__default.oneOf([DIRECTION.UP, DIRECTION.LEFT, DIRECTION.RIGHT, DIRECTION.DOWN]),
  title: PropTypes__default.string
};
CaretIcon.defaultProps = {
  color: '#535353'
};
var StyledSpan = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n\tcursor: ", ";\n\ttransform: ", "\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
}, function (_ref2) {
  var canClick = _ref2.canClick;
  return canClick ? 'pointer' : 'normal';
}, function (props) {
  switch (props.direction) {
    case DIRECTION.DOWN:
      return 'rotate(90deg)';
    case DIRECTION.LEFT:
      return 'rotate(180deg)';
    case DIRECTION.UP:
      return 'rotate(270deg)';
    default:
      return '';
  }
});
var _templateObject$1;
var StepButtonStyle = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n\twidth: 30px;\n\theight: 30px;\n\tborder: ", ";\n\tbackground-color: ", ";\n\tcursor: ", ";\n\tdisplay: flex;\n\talign-content: center;\n\tjustify-content: center;\n"])), function (_ref) {
  var theme = _ref.theme;
  return "1px solid ".concat(theme.border.primary);
}, function (_ref2) {
  var enabled = _ref2.enabled,
    theme = _ref2.theme;
  return enabled ? theme.background.primary : theme.background.secondary;
}, function (_ref3) {
  var enabled = _ref3.enabled;
  return enabled ? 'pointer' : 'normal';
});
var StepButton = function StepButton(_ref4) {
  var direction = _ref4.direction,
    onClick = _ref4.onClick,
    enabled = _ref4.enabled,
    userpilot = _ref4.userpilot,
    cy = _ref4.cy;
  var iconDirection = direction === 'back' ? CaretIcon.DIRECTION.LEFT : CaretIcon.DIRECTION.RIGHT;
  return /*#__PURE__*/React__default.createElement(StepButtonStyle, {
    onClick: onClick,
    enabled: enabled,
    "data-userpilot": userpilot,
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(CaretIcon, {
    direction: iconDirection,
    size: CaretIcon.SIZE.STANDARD,
    color: enabled ? '#4C4C58' : '#A5A5AE'
  }));
};
StepButton.propTypes = {
  direction: PropTypes.oneOf(['back', 'forward']).isRequired,
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  /**
   * ID needed for on-boarding tool
   */
  userpilot: PropTypes.string,
  /**
   * ID needed for Cypress testing
   */
  cy: PropTypes.string
};
var _templateObject$2;
var StepContentStyle = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tborder-top: ", ";\n\tborder-bottom: ", ";\n\theight: 30px;\n\tmin-width: fit-content;\n\twidth: ", "px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\ttext-transform: uppercase;\n\tfont-size: 10px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tfont-weight: 500;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.background.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid ".concat(theme.border.primary);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid ".concat(theme.border.primary);
}, function (_ref4) {
  var width = _ref4.width;
  return width;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typographyLight.primary;
});
var StepContent = function StepContent(_ref6) {
  var content = _ref6.content,
    width = _ref6.width,
    userpilot = _ref6.userpilot,
    cy = _ref6.cy;
  return /*#__PURE__*/React__default.createElement(StepContentStyle, {
    width: width,
    "data-userpilot": userpilot,
    "data-cy": cy
  }, content);
};
StepContent.propTypes = {
  content: PropTypes.node.isRequired,
  width: PropTypes.number.isRequired,
  /**
   * ID needed for on-boarding tool
   */
  userpilot: PropTypes.string,
  /**
   * ID needed for Cypress testing
   */
  cy: PropTypes.string
};
var _templateObject$3;
var StepperStyle = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\n\tuser-select: none;\n"])));
var Stepper = function Stepper(_ref) {
  var children = _ref.children,
    onBack = _ref.onBack,
    onForward = _ref.onForward,
    width = _ref.width,
    canNavigateBack = _ref.canNavigateBack,
    canNavigateForward = _ref.canNavigateForward,
    userpilot = _ref.userpilot,
    cy = _ref.cy;
  var navigateBack = React.useMemo(function () {
    return canNavigateBack ? onBack : undefined;
  }, [canNavigateBack, onBack]);
  var navigateForward = React.useMemo(function () {
    return canNavigateForward ? onForward : undefined;
  }, [canNavigateForward, onForward]);
  return /*#__PURE__*/React__default.createElement(StepperStyle, {
    "data-userpilot": userpilot,
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(StepButton, {
    direction: "back",
    enabled: canNavigateBack,
    onClick: navigateBack,
    userpilot: "".concat(userpilot, "-back"),
    cy: "".concat(cy, "-back")
  }), /*#__PURE__*/React__default.createElement(StepContent, {
    content: children,
    width: width,
    userpilot: "".concat(userpilot, "-content"),
    cy: "".concat(cy, "-content")
  }), /*#__PURE__*/React__default.createElement(StepButton, {
    direction: "forward",
    enabled: canNavigateForward,
    onClick: navigateForward,
    userpilot: "".concat(userpilot, "-forward"),
    cy: "".concat(cy, "-forward")
  }));
};
Stepper.propTypes = {
  /**
   * What to be displayed in the content box. This is flexible and doesn't have to be text only. Content
   * has to fit withing 30px height
   */
  children: PropTypes.node.isRequired,
  /**
   * Callback function, invoked when the user has clicked the back button
   */
  onBack: PropTypes.func.isRequired,
  /**
   * Callback function, invoked when the user has clicked the forward button
   */
  onForward: PropTypes.func.isRequired,
  /**
   * The width of the content box
   */
  width: PropTypes.number.isRequired,
  /**
   * Determines if it is possible click the navigate back.
   */
  canNavigateBack: PropTypes.bool,
  /**
   * Determines if it is possible click the navigate forward.
   */
  canNavigateForward: PropTypes.bool,
  /**
   * ID needed for on-boarding tool
   */
  userpilot: PropTypes.string,
  /**
   * ID needed for Cypress testing
   */
  cy: PropTypes.string
};
Stepper.defaultProps = {
  canNavigateBack: true,
  canNavigateForward: true
};
var YearStepper = function YearStepper(_ref) {
  var startYear = _ref.startYear,
    onYearChanged = _ref.onYearChanged,
    minYear = _ref.minYear,
    maxYear = _ref.maxYear,
    userpilot = _ref.userpilot,
    cy = _ref.cy;
  var _useState = React.useState(startYear),
    _useState2 = _slicedToArray(_useState, 2),
    year = _useState2[0],
    setYear = _useState2[1];
  var changeYear = function changeYear(newYear) {
    setYear(newYear);
    if (onYearChanged) {
      onYearChanged(newYear);
    }
  };
  var prevYear = function prevYear() {
    return changeYear(year - 1);
  };
  var nextYear = function nextYear() {
    return changeYear(year + 1);
  };
  var canNavigateBack = minYear !== undefined && minYear !== null ? year > minYear : true;
  var canNavigateForward = maxYear !== undefined && maxYear !== null ? year < maxYear : true;
  return /*#__PURE__*/React__default.createElement(Stepper, {
    width: 63,
    onForward: nextYear,
    onBack: prevYear,
    canNavigateBack: canNavigateBack,
    canNavigateForward: canNavigateForward,
    userpilot: userpilot,
    cy: cy
  }, year);
};
YearStepper.propTypes = {
  /**
   * Set what year to show initially. Defaults to current year
   */
  startYear: PropTypes.number,
  onYearChanged: PropTypes.func,
  minYear: PropTypes.number,
  maxYear: PropTypes.number,
  /**
   * ID needed for on-boarding tool
   */
  userpilot: PropTypes.string,
  /**
   * ID needed for Cypress testing
   */
  cy: PropTypes.string
};
YearStepper.defaultTypes = {
  startYear: new Date().getFullYear()
};
var WeekStepper = function WeekStepper(_ref) {
  var startDate = _ref.startDate,
    onWeekChanged = _ref.onWeekChanged,
    canGoBack = _ref.canGoBack,
    canGoForward = _ref.canGoForward,
    locale = _ref.locale,
    userpilot = _ref.userpilot,
    cy = _ref.cy;
  var initialDate = React.useMemo(function () {
    var initDate = startDate ? startDate : moment();
    if (locale) {
      initDate.locale(locale);
    }
    return initDate;
  }, []);
  var _useState = React.useState(function () {
      return {
        startDate: initialDate.clone().startOf('week'),
        endDate: initialDate.clone().endOf('week')
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    selectedWeek = _useState2[0],
    setSelectedWeek = _useState2[1];
  React.useEffect(function () {
    if (onWeekChanged) {
      onWeekChanged(selectedWeek);
    }
  }, [selectedWeek]);
  var prevWeek = function prevWeek() {
    var newEndDate = selectedWeek.startDate.clone().subtract(1, 'day');
    var newStartDate = newEndDate.clone().startOf('week');
    setSelectedWeek({
      startDate: newStartDate,
      endDate: newEndDate
    });
  };
  var nextWeek = function nextWeek() {
    var newStartDate = selectedWeek.endDate.clone().add(1, 'day');
    var newEndDate = newStartDate.clone().endOf('week');
    setSelectedWeek({
      startDate: newStartDate,
      endDate: newEndDate
    });
  };
  return /*#__PURE__*/React__default.createElement(Stepper, {
    width: 110,
    onForward: nextWeek,
    onBack: prevWeek,
    canNavigateBack: canGoBack,
    canNavigateForward: canGoForward,
    userpilot: userpilot,
    cy: cy
  }, "".concat(selectedWeek.startDate.format('DD MMM'), " - ").concat(selectedWeek.endDate.format('DD MMM')));
};
WeekStepper.propTypes = {
  /**
   * Set what week to select to begin with. The date should be within the week and be a moment date.
   * Defaults to current week.
   */
  startDate: PropTypes.object,
  onWeekChanged: PropTypes.func,
  canGoBack: PropTypes.bool,
  canGoForward: PropTypes.bool,
  /**
   * Override the global locale for this specific instance. Shouldn't have to be used and is currently primarily used
   * for demo purposes.
   */
  locale: PropTypes.object,
  /**
   * ID needed for on-boarding tool
   */
  userpilot: PropTypes.string,
  /**
   * ID needed for Cypress testing
   */
  cy: PropTypes.string
};
WeekStepper.defaultTypes = {
  canGoBack: true,
  canGoForward: true
};
exports.Stepper = Stepper;
exports.WeekStepper = WeekStepper;
exports.YearStepper = YearStepper;